module.exports = __webpack_public_path__ + "static/media/trash.9a80b480.svg";